import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { TuiMonth, TUI_FIRST_DAY, TUI_LAST_DAY, tuiDefaultProp, TuiFocusableModule } from '@taiga-ui/cdk';
import { CommonModule } from '@angular/common';
import { TuiLinkModule } from '@taiga-ui/core/components/link';
import { TuiPrimitiveSpinButtonModule } from '@taiga-ui/core/components/primitive-spin-button';
import { TuiMonthPipeModule } from '@taiga-ui/core/pipes';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/components/primitive-spin-button';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@taiga-ui/core/components/link';
import * as ɵngcc4 from '@taiga-ui/cdk';
import * as ɵngcc5 from '@taiga-ui/core/pipes';

function TuiPrimitiveYearMonthPaginationComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.value.formattedYear, " ");
} }
function TuiPrimitiveYearMonthPaginationComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function TuiPrimitiveYearMonthPaginationComponent_ng_template_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onYearClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tuiFocusable", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.value.formattedYear, " ");
} }
let TuiPrimitiveYearMonthPaginationComponent = class TuiPrimitiveYearMonthPaginationComponent {
    constructor() {
        this.value = TuiMonth.currentLocal();
        this.min = TUI_FIRST_DAY;
        this.max = TUI_LAST_DAY;
        this.valueChange = new EventEmitter();
        this.yearClick = new EventEmitter();
    }
    get prevMonthDisabled() {
        return this.value.monthSameOrBefore(this.min);
    }
    get nextMonthDisabled() {
        return this.value.monthSameOrAfter(this.max);
    }
    get oneYear() {
        return this.min.year === this.max.year;
    }
    onYearClick() {
        this.yearClick.next(this.value);
    }
    onPrevMonthClick() {
        this.appendValueWithLimit({ month: -1 });
    }
    onNextMonthClick() {
        this.appendValueWithLimit({ month: 1 });
    }
    appendValueWithLimit(date) {
        const newMonth = this.value.append(date);
        if (this.min.monthSameOrAfter(newMonth)) {
            this.updateValue(this.min);
            return;
        }
        if (this.max.monthSameOrBefore(newMonth)) {
            this.updateValue(this.max);
            return;
        }
        this.updateValue(newMonth);
    }
    updateValue(value) {
        if (this.value.monthSame(value)) {
            return;
        }
        this.value = value;
        this.valueChange.emit(value);
    }
};
TuiPrimitiveYearMonthPaginationComponent.ɵfac = function TuiPrimitiveYearMonthPaginationComponent_Factory(t) { return new (t || TuiPrimitiveYearMonthPaginationComponent)(); };
TuiPrimitiveYearMonthPaginationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiPrimitiveYearMonthPaginationComponent, selectors: [["tui-primitive-year-month-pagination"]], inputs: { value: "value", min: "min", max: "max" }, outputs: { valueChange: "valueChange", yearClick: "yearClick" }, decls: 7, vars: 10, consts: [[3, "focusable", "leftDisabled", "rightDisabled", "leftClick", "rightClick"], [4, "ngIf", "ngIfElse"], ["button", ""], ["automation-id", "tui-primitive-year-month-pagination__year-button", "tuiLink", "", "type", "button", 3, "tuiFocusable", "click"]], template: function TuiPrimitiveYearMonthPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "tui-primitive-spin-button", 0);
        ɵngcc0.ɵɵlistener("leftClick", function TuiPrimitiveYearMonthPaginationComponent_Template_tui_primitive_spin_button_leftClick_0_listener() { return ctx.onPrevMonthClick(); })("rightClick", function TuiPrimitiveYearMonthPaginationComponent_Template_tui_primitive_spin_button_rightClick_0_listener() { return ctx.onNextMonthClick(); });
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵpipe(3, "tuiMonth");
        ɵngcc0.ɵɵtemplate(4, TuiPrimitiveYearMonthPaginationComponent_ng_container_4_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(5, TuiPrimitiveYearMonthPaginationComponent_ng_template_5_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵproperty("focusable", false)("leftDisabled", ctx.prevMonthDisabled)("rightDisabled", ctx.nextMonthDisabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 6, ɵngcc0.ɵɵpipeBind1(3, 8, ctx.value)), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.oneYear)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.TuiPrimitiveSpinButtonComponent, ɵngcc2.NgIf, ɵngcc3.TuiLinkComponent, ɵngcc4.TuiFocusableDirective], pipes: [ɵngcc2.AsyncPipe, ɵngcc5.TuiMonthPipe], styles: ["[_nghost-%COMP%]{display:block}"] });
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "value", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "max", void 0);
__decorate([
    Output()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "valueChange", void 0);
__decorate([
    Output()
], TuiPrimitiveYearMonthPaginationComponent.prototype, "yearClick", void 0);

let TuiPrimitiveYearMonthPaginationModule = class TuiPrimitiveYearMonthPaginationModule {
};
TuiPrimitiveYearMonthPaginationModule.ɵfac = function TuiPrimitiveYearMonthPaginationModule_Factory(t) { return new (t || TuiPrimitiveYearMonthPaginationModule)(); };
TuiPrimitiveYearMonthPaginationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiPrimitiveYearMonthPaginationModule });
TuiPrimitiveYearMonthPaginationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiFocusableModule,
            TuiPrimitiveSpinButtonModule,
            TuiLinkModule,
            TuiMonthPipeModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveYearMonthPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'tui-primitive-year-month-pagination',
                template: "<tui-primitive-spin-button\n    [focusable]=\"false\"\n    [leftDisabled]=\"prevMonthDisabled\"\n    [rightDisabled]=\"nextMonthDisabled\"\n    (leftClick)=\"onPrevMonthClick()\"\n    (rightClick)=\"onNextMonthClick()\"\n>\n    {{ value | tuiMonth | async }}\n    <ng-container *ngIf=\"oneYear; else button\">\n        {{ value.formattedYear }}\n    </ng-container>\n    <ng-template #button>\n        <button\n            automation-id=\"tui-primitive-year-month-pagination__year-button\"\n            tuiLink\n            type=\"button\"\n            [tuiFocusable]=\"false\"\n            (click)=\"onYearClick()\"\n        >\n            {{ value.formattedYear }}\n        </button>\n    </ng-template>\n</tui-primitive-spin-button>\n",
                styles: [":host{display:block}"]
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], yearClick: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveYearMonthPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiFocusableModule,
                    TuiPrimitiveSpinButtonModule,
                    TuiLinkModule,
                    TuiMonthPipeModule,
                ],
                declarations: [TuiPrimitiveYearMonthPaginationComponent],
                exports: [TuiPrimitiveYearMonthPaginationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPrimitiveYearMonthPaginationModule, { declarations: function () { return [TuiPrimitiveYearMonthPaginationComponent]; }, imports: function () { return [CommonModule,
        TuiFocusableModule,
        TuiPrimitiveSpinButtonModule,
        TuiLinkModule,
        TuiMonthPipeModule]; }, exports: function () { return [TuiPrimitiveYearMonthPaginationComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPrimitiveYearMonthPaginationComponent, TuiPrimitiveYearMonthPaginationModule };

